var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSasWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 8.078 8.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.158.001c-.28-.006-.567.026-.862.1-1.364.34-2.89 2.096-1.224 4.12l.995 1.205.28.343c.19.224.497.22.724.033s.293-.496.105-.724l-.114-.138h.005l-.162-.2-.77-.933c-.724-.88-.4-1.964.58-2.58.865-.543 2.453-.35 3 .543C6.37.76 5.366.028 4.158.001zm.2 2.124a.57.57 0 0 0-.376.138c-.228.188-.292.496-.105.724a7.91 7.91 0 0 0 .062.076l1.005 1.214c.724.88.4 1.96-.58 2.576-.865.543-2.453.35-3-.543.424 1.252 1.846 2.07 3.42 1.676 1.365-.34 2.89-2.09 1.224-4.115l-1.167-1.4-.133-.167a.47.47 0 0 0-.348-.171z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSasWhite);
export default __webpack_public_path__ + "static/media/sas-white.9478d6ed384ee938bb2a64288c8faa17.svg";
export { ForwardRef as ReactComponent };